import { GrowthBook } from '@growthbook/growthbook-react';
import { waitForRuntimeConfig } from './runtimeConfig';

type GrowthbookConfigSource = {
  REACT_APP_GROWTHBOOK_CLIENT_KEY?: string;
  REACT_APP_GROWTHBOOK_API_HOST?: string;
};

let growthbookInstance: GrowthBook | null = null;
let growthbookInitPromise: Promise<GrowthBook> | null = null;

export const initializeGrowthbook = (config: GrowthbookConfigSource = {}): GrowthBook => {
  if (growthbookInstance) {
    return growthbookInstance;
  }

  const { REACT_APP_GROWTHBOOK_API_HOST, REACT_APP_GROWTHBOOK_CLIENT_KEY } = config;

  growthbookInstance = new GrowthBook({
    apiHost: REACT_APP_GROWTHBOOK_API_HOST,
    clientKey: REACT_APP_GROWTHBOOK_CLIENT_KEY,
    enableDevMode: process.env.REACT_APP_ENV !== 'production',
  });

  growthbookInitPromise = Promise.resolve(growthbookInstance);

  return growthbookInstance;
};

export const getGrowthbookInstance = async (): Promise<GrowthBook> => {
  if (growthbookInstance) {
    return growthbookInstance;
  }

  if (!growthbookInitPromise) {
    growthbookInitPromise = waitForRuntimeConfig().then((config) =>
      initializeGrowthbook({
        REACT_APP_GROWTHBOOK_API_HOST: config.REACT_APP_GROWTHBOOK_API_HOST,
        REACT_APP_GROWTHBOOK_CLIENT_KEY: config.REACT_APP_GROWTHBOOK_CLIENT_KEY,
      }),
    );
  }

  return growthbookInitPromise;
};
